'use strict';

/**
 * @ngdoc function
 * @name thothAppApp.controller:UserShowCtrl
 * @description
 * # UserShowCtrl
 * Controller of the thothAppApp
 */
angular.module('thothApp.controllers')
  .controller('UserShowCtrl', [
    '$scope', '$state', '$stateParams', 'User', function ($scope, $state, $stateParams, User) {
      $scope.user = {};
      User.find($stateParams.userId).then(function(response) {
        $scope.user = response.data.user;
      }, function(error) {
        User.error(error);
      });
  }]);
